import PropTypes from "prop-types";
import styles from "./utility-area-ride.module.less";
import SiteConfigurationStore from "components/stores/site-configuration-store";
import QueueTimeDisplay from "components/block-elements/queue-time-display/queue-time-display";

const UtilityAreaRide = (props) => {
  const noHeightLimitLabel = SiteConfigurationStore.getLabel("NO_HEIGHT_LIMIT");
  const couponLabel = SiteConfigurationStore.getLabel("COUPONS");
  const separateTicketLabel = SiteConfigurationStore.getLabel("SEPARATE_TICKET");

  return props.minimumHeight ||
    props.couponCount ||
    props.couponText ||
    props.separateTickets ||
    props.ageRequirement ||
    props.noHeightRequirement ? (
    <div className={[styles.utilityOuterWrapper, props.visible ? styles.visible : ""].join(" ")}>
      {props.visible && (
        <div className={["block--padded", styles.utilityWrapper, props.extraClass].join(" ")}>
          {props.visible && props.minimumHeight && (
            <span className={[styles.utilityShowText, "p_small"].join(" ")}>
              <span className={["icon-length", styles.utilityIcon].join(" ")} />
              <span className={styles.utilityAreaTime}>{props.minimumHeight}</span>
            </span>
          )}
          {props.visible && props.ageRequirement && (
            <span className={[styles.utilityShowText, "p_small"].join(" ")}>
              <span className={["icon-length", styles.utilityIcon].join(" ")} />
              <span className={styles.utilityAreaTime}>{props.ageRequirement}</span>
            </span>
          )}
          {props.visible && props.noHeightRequirement && (
            <span className={[styles.utilityShowText, "p_small"].join(" ")}>
              <span className={["icon-length", styles.utilityIcon].join(" ")} />
              <span className={styles.utilityAreaTime}>{noHeightLimitLabel ? noHeightLimitLabel : ""}</span>
            </span>
          )}
          {props.visible && (props.couponCount || props.couponText) && (
            <span className={[styles.utilityShowText, "p_small"].join(" ")}>
              <span className={["icon-tickets", styles.utilityIcon].join(" ")} />
              <span className={styles.utilityAreaTime}>
                {props.couponText ? props.couponText : props.couponCount + " " + (couponLabel ? couponLabel : "")}
              </span>
            </span>
          )}
          {props.visible && props.separateTickets && (
            <span className={[styles.utilityShowText, "p_small"].join(" ")}>
              <span className={["icon-tickets", styles.utilityIcon].join(" ")} />
              <span className={styles.utilityAreaTime}>{separateTicketLabel ? separateTicketLabel : ""}</span>
            </span>
          )}
          {props.visible && !!props.queueTime && (
            <span className={[styles.utilityShowText, "p_small"].join(" ")}>
              <span className={["icon-time", styles.utilityIcon].join(" ")} />
              <span className={styles.utilityAreaTime}>
                <QueueTimeDisplay queueTime={props.queueTime} />
              </span>
            </span>
          )}
        </div>
      )}
    </div>
  ) : null;
};

UtilityAreaRide.propTypes = {
  onClickButton: PropTypes.func,
};

export default UtilityAreaRide;
